import React from 'react';
import '../scss/account-action-modal.style.scss';

interface DeleteAccountModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteAccountModal: React.FC<DeleteAccountModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    // TODO: Add API call for account deletion
    onConfirm();
  };

  return (
    <div className="account-action-modal-overlay" onClick={onClose}>
      <div className="account-action-modal-container delete-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <h2 className="modal-title">Delete account</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#252525"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          {/* Sad Message Badge */}
          <div className="sad-message-badge">
            <span className="emoji">😔</span>
            <span className="message">It's sad to see you go.</span>
          </div>

          {/* Detailed Message */}
          <div className="modal-message delete-message">
            <p>
              This action will permanently delete your account and all associated data from our
              systems.
            </p>
            <p>
              In accordance with Swedish law, your data will be securely retained for up to 12
              months before being fully erased from our database.
            </p>
            <p className="after-deletion-title">After deletion:</p>
            <ul className="deletion-consequences">
              <li>You will lose access to all services and history.</li>
              <li>This action cannot be undone.</li>
            </ul>
          </div>

          <button className="modal-action-btn" onClick={handleConfirm}>
            <span>Yes, delete my account</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountModal;
